export default "__VITE_ASSET__CGSA2cC2__"